module.exports = __webpack_public_path__ + "static/media/friend_lists.0139a85a.png";